import { PaysafeBillingAddress } from './paysafe-billing-address.interface';
import { PaysafeShippingAddress } from './paysafe-shipping-address.interface';

export interface PaysafeCustomerDetails {
  holderName?: string;
  billingDetails?: PaysafeBillingAddress;
  shippingDetails?: PaysafeShippingAddress;
}
